export enum IndexIds {
  FranklinQualityDividendIndex = 'COIPFQDIBDP',
  FranklinFactorsUSIndex = 'COIPFFUSIBDP',
  FranklinBofAWorldIndex = 'COIPBWEIBDP',
  FranklinUSCoreIndex = 'COIPFUSCIBDP',
  FranklinUSCoreBalancedIndex = 'COIPFUSCBIBD',
}
